import { useState, useEffect, useRef } from "react";
import axios from 'axios';
import strings from './strings.json';
import invoiceimg from "./invoiceimg.json";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import md5 from 'md5';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

function Taxi({ lang }) {
  const [modal, setModal] = useState(false);
  const [addmodal, setAddModal] = useState(false);
  const [carId, setCarId] = useState("");
  const [bags, setBags] = useState("");
  const [passengers, setPassengers] = useState("");
  const [file_no, setFile_no] = useState("");
  const [mobile, setMobile] = useState("");
  const [plate, setPlate] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [rpt, setRpt] = useState("");
  const [opDate, setOpDate] = useState("");
  const [company, setCompany] = useState("");
  const [disableComp, setDisableComp] = useState(false);
  const [last, setLast] = useState(""); // Last index ID of Data
  const companies = ['HARD ROCK RIDERS', 'BRAXTONE PLUS', 'GULF ASSIST CO'];
  const tableRef = useRef(null);
  const [totalPrice, setTotalPrice] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dldmodal, setDldModal] = useState(false);

  const generatePdf = ( invoiceNumber ) => {
      const element = document.getElementById("content");
      html2canvas(element)
        .then(() => {
          // const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF();
          const vat = totalPrice * 0.1;
          pdf.addImage(invoiceimg.svg, 0, 0, 210, 300);
          pdf.setFontSize(13);
          pdf.text(invoiceNumber, 166, 81);
          pdf.text(company+" W.L.L", 21, 83);
          if (company === 'GULF ASSIST CO') {
          pdf.text("Office#11 Bulding#2332 Road#2830 Block#428", 21, 90);
          pdf.text("Al Seef District P.O.Box:2790 Manama", 21, 97);
          pdf.text("Kingdom of Bahrain TRN:220000618700002", 21, 104);
          } else if (company === 'BRAXTONE PLUS') {
          pdf.text("Flat/Shop No. 21, Building 2304, Road/Street 2830", 21, 90);
          pdf.text("AL SEEF, Block 428 Bahrain", 21, 97);
          pdf.text("TAN: 220001304300002 CR NO. 86167-1", 21, 104);
          } else {
          pdf.text("Office#1775 Road#840 Block708 Salmabad", 21, 90);
          pdf.text("TAN:220019160900002 CR NO. 152036-1", 21, 97 );
          }
          pdf.text(new Date((new Date().getTime()) + 3 * 60 * 60 * 1000).toISOString().split("T")[0], 163, 98); // Right
          pdf.text("Taxi services ("+filteredData.length+") : " + startDate + " - " + endDate, 21, 137);
          pdf.text(totalPrice+" BD", 143, 137); // Right
          pdf.text(vat.toFixed(3)+" BD", 143, 199);
          pdf.text((totalPrice+vat)+" BD", 143, 221);
          setTimeout(() => {
            pdf.save(invoiceNumber+".pdf");
            openDownloadModal();
            addInvoice();
          }, 1000);
        })
        .catch((error) => {
          console.error("Error generating PDF:", error);
        });
    };

  const handleCompany = (event) => {
    setCompany(event.target.value);
    setDisableComp(true);
  };

  const openModal = (cId, cBags, cPassengers, cDate, cFrom, cTo, cFile_no, cMobile, cPlate, cRpt, cCompany) => {
    setCarId(cId);
    setBags(cBags);
    setPassengers(cPassengers);
    setOpDate(cDate);
    setFrom(cFrom);
    setTo(cTo);
    setFile_no(cFile_no);
    setMobile(cMobile);
    setPlate(cPlate);
    setRpt(cRpt);
    setCompany(cCompany);
    setModal(!modal);
    const modalDiv = document.querySelector(".booking-modal__car-info");
    modalDiv.scroll(0, 0);
  }

  let [filteredData,setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const closeModal = () => {
    setModal(!modal);
    setPassengers("");
    setBags("");
    setOpDate("");
    setFrom("");
    setTo("");
    setRpt("");
    setFile_no("");
    setMobile("");
    setPlate("");
    setCompany("");
    setDisableComp(false);
  }

  const closeAddModal = () => {
    document.getElementById("myCompany").selectedIndex = 0;
    setBags("");
    setPassengers("");
    setOpDate("");
    setFrom("");
    setTo("");
    setRpt("");
    setFile_no("");
    setMobile("");
    setPlate("");
    setCompany("");
    setDisableComp(false);
    setAddModal(!addmodal);
  }

  const addModal = () => {
    setAddModal(!addmodal);
    const modalDiv = document.querySelector(".booking-modal__car-info");
    modalDiv.scroll(0, 0);
  }

  const [data, setData] = useState([]);

  const fetchData = async(e) => {
    try {
      const response = await axios({
        method: "get",
        url: "https://api.hardrockrental.net/getTaxi.php",
        headers: { "Content-Type": "multipart/form-data" },
      });
      setFilteredData(response.data);
      setData(response.data);
      setLast(response.data[response.data.length-1].id+1);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  var bodyFormData = new FormData();

  const updateTaxi = async() => {
  bodyFormData.append('id', carId);
  bodyFormData.append('company', company);
  bodyFormData.append('bags', bags);
  bodyFormData.append('passengers', passengers);
  bodyFormData.append('tdate', opDate);
  bodyFormData.append('point1', from);
  bodyFormData.append('point2', to);
  bodyFormData.append('file_no', file_no);
  bodyFormData.append('mobile', mobile);
  bodyFormData.append('plate', plate);
  bodyFormData.append('rpt', rpt);
  bodyFormData.append('signature2', sessionStorage.getItem("userdata"));
    try {
      await axios({
        method: "post",
        url: "https://api.hardrockrental.net/updateTaxi.php",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      closeModal();
      fetchData();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  var formData = new FormData();
  formData.append('id', last);

  const addTaxi = async() => {
    formData.append('company', company);
    formData.append('bags', bags);
    formData.append('passengers', passengers);
    formData.append('tdate', opDate);
    formData.append('point1', from);
    formData.append('point2', to);
    formData.append('file_no', file_no);
    formData.append('mobile', mobile);
    formData.append('plate', plate);
    formData.append('rpt', rpt);
    formData.append('signature', sessionStorage.getItem("userdata"));
    formData.append('signature2', sessionStorage.getItem("userdata"));

    try {
      await axios({
        method: "post",
        url: "https://api.hardrockrental.net/addTaxi.php",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      setAddModal(!addmodal);
      setBags("");
      setPassengers("");
      setOpDate("");
      setFrom("");
      setTo("");
      setRpt("");
      setFile_no("");
      setMobile("");
      setPlate("");
      setCompany("");
      setDisableComp(false);
      fetchData();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const openDownloadModal = () => {
    document.getElementById("myCompany1").selectedIndex = 0;
    setDldModal(!dldmodal);
    setDisableComp(false);
    setCompany("");
    setStartDate("");
    setEndDate("");
    fetchData();
    const modalDiv = document.querySelector(".booking-modal__car-info");
    modalDiv.scroll(0, 0);
  }

  const taxiDld = (e) => {
    setEndDate(e);
    filteredData = data.filter(taxi => {
      const expiry = new Date(taxi.tdate);
      const start = new Date(startDate);
      const end = new Date(e);
  
      return (
          (start && end && expiry >= start && expiry <= end) &&
          (company === "" || taxi.company.toLowerCase() === company.toLowerCase())
      );
  });
  
  setTotalPrice(filteredData.reduce((sum, truck) => sum + truck.rpt, 0));
  setFilteredData(filteredData);
  }
  
  const getInvoice = async() => {
    try {
      const response = await axios({
        method: "post",
        url: "https://api.hardrockrental.net/getInvoice.php",
        data: {"inv": "taxi"},
        headers: { "Content-Type": "multipart/form-data" },
      });
    const invoiced = (parseInt(response.data.invoiced)+1).toString().padStart(2, "0");
    const yearPrefix = new Date().getFullYear().toString().slice(-2); // Get last two digits of the current year
    const invoiceNumber = "TXI"+yearPrefix+invoiced;
    generatePdf(invoiceNumber);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
  
  const addInvoice = async() => {
    try {
      await axios({
        method: "post",
        url: "https://api.hardrockrental.net/addInvoice.php",
        data: {"inv": "taxi"},
        headers: { "Content-Type": "multipart/form-data" },
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const [visibleRows, setVisibleRows] = useState(10);
  
    const handleLoadMore = () => {
      setVisibleRows((prevRows) => prevRows + 10);
    };
  
    const handleShowAll = () => {
      setVisibleRows(data.length);
    };
  
    const handleLoadLess = () => {
      setVisibleRows((prevRows) => prevRows - 10);
    };
  

  const searchSpace = (event) => {
    setSearch(event.target.value);
    if(event.target.value === "") {
      setFilteredData(data);
    } else {
      filteredData = data.filter((datas)=>{
        if((datas.plate).includes(search) || (datas.mobile).includes(search) || (datas.file_no).includes(search) || (datas.company).includes(search.toUpperCase())){
          console.log(datas);
          return datas
        } else {
          return false;
        }
      });
      setFilteredData(filteredData);
    }
  }

  const today = new Date();
  const formattedDate = today.toLocaleDateString();
  
  return (
    <>
      <div className="team-container" id="content" style={{ paddingBottom: "0px" }}>
        <p>
        {strings[lang].Vehicles1} {sessionStorage.getItem("userdata").toUpperCase()}{" "}
          <i className="fa-regular fa-face-grin-beam"></i>
          <br></br> {strings[lang].Vehicles2} <b>{data.length} {strings[lang].Taxi1}</b>
        </p>
        <input placeholder={strings[lang].Vehicles5} value={search} id="search" type="text" onChange={(e)=>searchSpace(e)}/>
        <button type="submit" style={{ borderRadius: "50px", boxShadow: "none"}} onClick={() => addModal()}>{strings[lang].Taxi2}</button><br></br>
      </div>
      <div className="book-content__box">
                <table
                ref={tableRef}
                style={{
                  alignSelf: "center",
                  textAlign: lang === "ar" ? "right" : "left",
                  fontSize: "15px",
                }}
              >
                <thead>
                <tr>
                  <th>#</th>
                  <th>{strings[lang].Taxi3}</th>
                  <th>{strings[lang].Form3}</th>
                  <th>{strings[lang].Rent5}</th>
                  <th>{strings[lang].Truck2}</th>
                  <th>{strings[lang].Truck3}</th>
                  <th>{strings[lang].Taxi4}</th>
                  <th>{strings[lang].Taxi5}</th>
                  <th>{strings[lang].Taxi6}</th>
                  <th>{strings[lang].Form51}</th>
                  <th>{strings[lang].Truck6}</th>
                  {sessionStorage.getItem("usertype") === md5("admin") && (
                  <>
                  <th><b>{strings[lang].Form39}</b></th>
                  <th><b>{strings[lang].Form61}</b></th>
                  </>
                )}
                  <th><i className="fa-solid fa-download" onClick={() => openDownloadModal()}></i></th>
                  {/* <th><DownloadTableExcel
                    filename={search+"_"+formattedDate}
                    sheet="Taxi"
                    currentTableRef={tableRef.current}
                ><i className="fa-solid fa-download"></i></DownloadTableExcel></th> */}
                </tr></thead>
        {filteredData &&
          filteredData.slice(0, visibleRows).map(function (d, idx) {
            return (
              <tbody key={idx}>
                <tr key={idx}>
                  <td>{idx+1}.</td>
                  <td>{d.file_no}</td>
                  <td>{d.mobile}</td>
                  <td>{d.plate}</td>
                  <td>{d.point1}</td>
                  <td>{d.point2}</td>
                  <td>{d.passengers}</td>
                  <td>{d.bags}</td>
                  <td>{d.rpt}</td>
                  <td>{d.tdate}</td>
                  <td>{d.company}</td>
                  {sessionStorage.getItem("usertype") === md5("admin") &&
                  <><td>{d.signature.toUpperCase()}</td>
                  <td>{d.signature2.toUpperCase()}</td></>}
                  <td style={{ padding: "2rem"}}><i className="fa-solid fa-pen-to-square" onClick={() => openModal(d.id, d.bags, d.passengers, d.tdate, d.point1, d.point2, d.file_no, d.mobile, d.file_no, d.rpt, d.company)}></i></td>
                </tr>
              </tbody>
            );
          })}
          {visibleRows < data.length && sessionStorage.getItem("usertype") === md5("admin") ? (
                        <tfoot><tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                        <i className="fa-solid fa-circle-chevron-down fa-lg" onClick={handleLoadMore}></i>
                        <i className="fa-solid fa-border-all fa-lg" style={{ marginLeft: "1rem" }} onClick={handleShowAll}></i>
                        {visibleRows > 10 ?<i className="fa-solid fa-circle-chevron-up fa-lg" style={{ marginLeft: "1rem" }} onClick={handleLoadLess}></i> : ""}
                        </td></tr></tfoot>)
                        : visibleRows < data.length && sessionStorage.getItem("usertype") === md5("team") ? (
                        <tfoot><tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                        <i className="fa-solid fa-circle-chevron-down fa-lg" onClick={handleLoadMore}></i>
                        <i className="fa-solid fa-border-all fa-lg" style={{ marginLeft: "1rem" }} onClick={handleShowAll}></i>
                        {visibleRows > 10 ?<i className="fa-solid fa-circle-chevron-up fa-lg" style={{ marginLeft: "1rem" }} onClick={handleLoadLess}></i> : ""}
                        </td></tr></tfoot>
                        ) : ""}
          </table>
      </div>

      {/* modal ------------------------------------ */}

      <div className={`booking-modal ${modal ? "active-modal" : ""}`}>
        {/* title */}
        {/* car info */}
        <div className="booking-modal__car-info">
              <div className="team-container__box">
                <h2>
                {/* <img src={carslist.find((brand) => brand.name === carName).logo} onClick={() => closeModal()} style={{ width: '50px' }} /> */}
                  <i className="fa-solid fa-pen-to-square fa-2xl" onClick={() => closeModal()}></i>
                  </h2><br></br>
                <h3 style={{ textAlign: "left", marginTop: "1.5rem"}}>#{carId === "" ? "" : carId}</h3>
                <select value={company} onChange={handleCompany}>
        {companies.map((data, idx) => (
              <option key={idx} value={data}> {data} </option>
        ))}
        </select>
                <input type="date" placeholder={opDate} value={opDate} onChange={(e) => setOpDate(e.target.value)} />
                <span><input type="text" placeholder="File number" value={file_no} onChange={(e) => setFile_no(e.target.value)} />
                <input type="text" placeholder="Mobile number" style={{ marginLeft: '10px' }} value={mobile} onChange={(e) => setMobile(e.target.value)} /></span>
                <span><input type="text" placeholder="Plate number" value={plate} onChange={(e) => setPlate(e.target.value)} />
                <input type="number" placeholder="Rate per Trip" value={rpt} style={{ marginLeft: '10px' }} onChange={(e) => setRpt(e.target.value)} /></span>
                <span><input type="number" placeholder={strings[lang].Taxi4} value={passengers} onChange={(e) => setPassengers(e.target.value)} />
                <input type="number" placeholder="Bags" value={bags} style={{ marginLeft: '10px' }} onChange={e => setBags(e.target.value)}/></span>
                <span><input type="text" placeholder="From" value={from} onChange={(e) => setFrom(e.target.value)} />
                <input type="text" placeholder="To" value={to} style={{ marginLeft: '10px' }} onChange={(e) => setTo(e.target.value)} /></span>
                <button type="submit" onClick={() => updateTaxi()}>
                {strings[lang].Vehicles38}
                </button> 
              </div>
        </div>
      </div>

      {/* modal ------------------------------------ */}

      <div className={`booking-modal ${addmodal ? "active-modal" : ""}`}>
        {/* title */}
        {/* car info */}
        <div className="booking-modal__car-info">
          <div className="team-container__box">
          <h2><i className="fa-regular fa-address-book fa-2xl" onClick={() => closeAddModal()}></i></h2><br></br>
          <h3 style={{ textAlign: "left", marginTop: "1.5rem"}}>#{last}</h3>
          <select disabled={disableComp} id="myCompany" onChange={handleCompany}>
            <option value="" >{strings[lang].Truck8}</option>
        {companies.map((data, idx) => (
              <option key={idx} value={data}> {data} </option>
        ))}
        </select>
        <input type="date" disabled={company === "" ? true : false} placeholder={strings[lang].Rent6} value={opDate} onChange={(e) => setOpDate(e.target.value)} />
                {/* {carLogo && (<img src={carLogo} alt="Custom Logo" style={{ width: '50px', height: '50px' }} />)}
                <select value={carName} onChange={e => setBags(e.target.value)}>
                <option>{strings[lang].Rent8}</option>
                {carslist && carslist.map(function(d, idx)
                { return (
                    <option value={d.name} key={idx} onClick={() => handleOptionClick(d.logo)}>{d.name}</option>
                )})}
                </select> */}
                <span><input type="text" disabled={company === "" ? true : false} placeholder="File number" value={file_no} onChange={(e) => setFile_no(e.target.value)} />
                <input type="text" disabled={company === "" ? true : false} placeholder="Mobile number" style={{ marginLeft: '10px' }} value={mobile} onChange={(e) => setMobile(e.target.value)} /></span>
                <span><input type="text" disabled={company === "" ? true : false} placeholder="Plate number" value={plate} onChange={(e) => setPlate(e.target.value)} />
                <input type="number" disabled={company === "" ? true : false} placeholder="Rate per Trip (BHD)" value={rpt} style={{ marginLeft: '10px' }} onChange={(e) => setRpt(e.target.value)} /></span>
                <span><input type="number" disabled={company === "" ? true : false} placeholder={strings[lang].Taxi4} value={passengers} onChange={(e) => setPassengers(e.target.value)} />
                <input type="number" disabled={company === "" ? true : false} placeholder={strings[lang].Taxi5} value={bags} style={{ marginLeft: '10px' }} onChange={(e) => setBags(e.target.value)} /></span>
                <span><input type="text" disabled={company === "" ? true : false} placeholder="From" value={from} onChange={(e) => setFrom(e.target.value)} />
                <input type="text" disabled={company === "" ? true : false} placeholder="To" value={to} style={{ marginLeft: '10px' }} onChange={(e) => setTo(e.target.value)} /></span>
                <button type="submit" disabled={company === "" ? true : false} style={{ backgroundColor: company === "" ? "grey" : "" }} onClick={() => addTaxi()}>
                {strings[lang].Vehicles37}
                </button> 
              </div>
        </div>
      </div>

      {/* ------------------------------------------- Download modal ----------------------------------- */}
      
            <div className={`booking-modal ${dldmodal ? "active-modal" : ""}`}>
              {/* title */}
              {/* car info */}
              <div className="booking-modal__car-info">
                <div className="team-container__box">
                <h2><i className="fa-solid fa-receipt fa-2xl" onClick={() => openDownloadModal()}></i></h2><br></br>
                <select disabled={disableComp} id="myCompany1" onChange={handleCompany}>
                <option value="" >{strings[lang].Truck8}</option>
              {companies.map((data, idx) => (
                    <option key={idx} value={data}> {data} </option>
              ))}
              </select>
              <span>
              <input type="date" disabled={company === "" ? true : false} placeholder={strings[lang].Rent6} value={startDate} onChange={(e) => setStartDate(e.target.value)} />
              <input type="date" disabled={startDate === "" ? true : false} placeholder={strings[lang].Rent6} value={endDate} style={{ marginLeft: "5px" }} onChange={(e) => taxiDld(e.target.value)} />
              </span>
              <button type="submit" disabled={company === "" ? true : false} style={{ backgroundColor: company === "" ? "grey" : "" }} onClick={() => getInvoice()} >
                {strings[lang].Form55} INVOICE
                </button>
                <button type="submit" disabled={company === "" ? true : false} style={{ backgroundColor: company === "" ? "grey" : "", marginTop: "15px" }} onClick={() => openDownloadModal()}>
                  <DownloadTableExcel
                    filename={company+"_"+formattedDate}
                    sheet="Taxi"
                    currentTableRef={tableRef.current}
                >{strings[lang].Form55} EXCEL</DownloadTableExcel></button>
                    </div>
              </div>
            </div>
    </>
  );
}

export default Taxi;
